import React, { useEffect, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import {
  apiCallVenueStarAdmin,
  apiCallVenueStarAdminAdd,
  apiCallRatingList,
} from "../../../../Core/Apicall";
import ChipSelector from "./ChipSelectorProps";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/Store";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";

interface VenueStarAdminProps {
  venueId: string;
}

const VenueStarAdmin: React.FC<VenueStarAdminProps> = ({ venueId }) => {
  const [rating, setRating] = useState<any>({});
  const [selectedQuestions, setSelectedQuestions] = useState<string[]>([]);
  const [page] = useState(1);
  const [rowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);

  const userdata: any = useSelector((state: RootState) => state.global.token);

  useEffect(() => {
    fetchData();
    fetchRatingData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await apiCallVenueStarAdmin({
        venueId,
        offset: page,
        limit: rowsPerPage,
      });
      if (res?.data) {
        const ids =
          res.data?.map((item: any) => item.questionId || item._id) || [];
        setSelectedQuestions(ids);
      }
    } catch (error: any) {
      toast.error(error?.message || "Failed to load data");
    }
  };

  const fetchRatingData = async () => {
    setLoading(true);
    try {
      const res = await apiCallRatingList({});
      setLoading(false);
      if (res?.data) setRating(res.data);
    } catch (error: any) {
      toast.error(error?.message || "Failed to load rating list");
    }
  };

  const handleSubmit = async () => {
    if (!userdata?.data?.userId) {
      toast.error("User not found");
      return;
    }

    setLoading(true);
    const data = {
      venueId,
      userId: userdata.data.userId,
      questionIds: selectedQuestions,
    };

    try {
      const res = await apiCallVenueStarAdminAdd(data);
      if (res?.message) {
        toast.success(res.message);
        fetchData();
      } else {
        toast.error("Submission failed");
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (updatedList: string[]) => {
    if (updatedList.length > 5) {
      toast.error("You can select a maximum of 5 questions");
      return;
    }
    setSelectedQuestions(updatedList);
  };

  return (
    <Box p={4} pt={2} pb={2}>
      {loading ? (
        <Stack spacing={3}>
          <CommonShimmer />
        </Stack>
      ) : (
        (Object.entries(rating) as [string, any[]][]).map(
          ([category, questions]) => {
            const sortedQuestions = [...questions].sort(
              (a, b) => a.displayOrder - b.displayOrder,
            );

            return (
              <Box key={category} mb={2}>
                <strong>{category}</strong>
                <ChipSelector
                  title=""
                  data={sortedQuestions}
                  labelKey="question"
                  selected={selectedQuestions}
                  setSelected={handleSelect}
                />
              </Box>
            );
          },
        )
      )}

      <Stack direction="row" spacing={2} mt={3}>
        <Button
          sx={{ backgroundColor: "black", color: "white" }}
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          Save
        </Button>
      </Stack>
    </Box>
  );
};

export default VenueStarAdmin;
